<template src="./Fare.html">
</template>

<script>
import {
  getRoutes,
  deleteRoute
} from '@/services/routes'

export default {
  name: 'Fare',
  data () {
    return {
      fares: []
    }
  },

  mounted () {
    this.loadFares()
  },

  methods: {

    loadFares () {
      getRoutes()
        .then(res => {
          this.fares = res.data || []
          this.fares.sort((a, b) => {
            if (a.is_active) {
              return 1
            } else if (b.is_active) {
              return -1
            }
            return 0
          })
        })
    },

    handleDeactivate (fare) {
      const status = fare.active ? 'Deactivated' : 'Activated'
      deleteRoute(fare.id)
        .then(() => {
          this.$notify({
            type: 'success',
            message: `Fare ${status} successfully`
          })
        })
        .catch((er) => {
          this.$notify.error('Error changing this Route/Fare status')
        })
    },

    editFare (item) {
      this.$router.push({ path: `/admin/fare/edit/${item.id}` })
    },

    gotoAddFare () {
      this.$router.push({ name: 'FareAdd' })
    }
  }
}
</script>

<style src="./fare.scss" lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/admin/fare/Fare.vue